import { appPath, servicesPath, defectsPath, feedbackPath } from "helpers/routePaths";

// Per-entity-type presentation registry: label plus detail route (LinkEntityId
// from the API is the parent record for child tables). A new record type is one
// entry here - nothing elsewhere branches on entity type.
//
// Labels come from the entity.* Site Terminology keys: the server serves them
// with the tenant's overrides applied, so one lookup gives both the tenant's
// wording and the active locale. me.customCaptions is the legacy path this
// replaces - reading it would pin the label to whatever was cached at mount.
export const ENTITY_TYPES = {
	service: {
		label: (t) => t("entity.service"),
		detailPath: (id) => `${appPath}${servicesPath}/${id}`,
	},
	defect: {
		label: (t) => t("entity.defect"),
		detailPath: (id) => `${appPath}${defectsPath}/${id}`,
	},
	feedback: {
		label: (t) => t("entity.feedback"),
		detailPath: (id) => `${appPath}${feedbackPath}/${id}`,
	},
	// Fixed UI vocabulary, not tenant terminology, so a label.* key not entity.*
	userAccess: {
		label: (t) => t("label.userAccess"),
		detailPath: null,
	},
};

const UNKNOWN_ENTITY = { label: (t, key) => key, detailPath: null };

export const entityTypeFor = (key) => ENTITY_TYPES[key] || UNKNOWN_ENTITY;
